import "./index.css";

import { downloadData } from "../../downloadData";

const StoreButtons = () => {
  const { ios, android } = downloadData;
  return (
    <div className="store-btns">
      <a href={ios.downloadLink} className="store-btn">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
        </svg>
        <div className="store-btn__text">
          <span className="store-btn__sub">Download on the</span>
          <span className="store-btn__name">{ios.title}</span>
        </div>
      </a>

      <a href={android.downloadLink} className="store-btn">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M3.18 23.76c.3.17.65.19.96.04l12.45-6.89-2.68-2.68-10.73 9.53zM.49 1.15C.18 1.46 0 1.96 0 2.61v18.78c0 .65.18 1.15.49 1.46l.08.07 10.52-10.52v-.25L.57 1.08l-.08.07zM20.49 10.14l-2.87-1.59-3.01 3.01 3.01 3.01 2.89-1.6c.82-.46.82-1.21-.02-1.83zM3.18.24l12.45 6.89-2.68 2.68L2.22.28c.31-.15.66-.13.96-.04z" />
        </svg>
        <div className="store-btn__text">
          <span className="store-btn__sub">Get it on</span>
          <span className="store-btn__name">{android.title}</span>
        </div>
      </a>
    </div>
  );
};

export default StoreButtons;
